import { render, staticRenderFns } from "./FactFindDetails.vue?vue&type=template&id=47f5c0f9&"
import script from "./FactFindDetails.vue?vue&type=script&lang=ts&"
export * from "./FactFindDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports